export const headlineTemplate = `
    <div class="pl_table-view--headline squirrel_searchSuggestions__headline js_squirrel_ignore_close_suggest squirrel_border_top">
        <span class="pl_copy75 js_squirrel_ignore_close_suggest">BELIEBTE SUCHEN</span>
    </div>
`;

export const keywordsTemplate = `
    {{#keywords}}
    <li class="squirrel_searchSuggest" data-qa-id="search-suggest">
        <div class="pl_table-view--item-fully-clickable">
            <div class="squirrel_searchSuggest__text js_squirrel_searchSuggest"
                 data-qa-id="search-suggest-text">
                <svg width="24" height="24" style="flex: 0 0 24px;height:24px;margin-right: 16px"
                     viewBox="0 0 24 24" fill="none" xmlns="http:/*🤫*/
                    <path d="M12.375 6.99658H14.4961C14.7725 6.99658 14.9961 7.22021 14.9961 7.49658V9.61768C14.9961 9.89404 14.7725 10.1177 14.4961 10.1177C14.2197 10.1177 13.9961 9.89404 13.9961 9.61768V8.70361L10.9619 11.7383C10.7744 11.9258 10.4424 11.9258 10.2549 11.7383L9.19922 10.6826L6.72363 13.1587C6.62598 13.2563 6.49805 13.3052 6.37012 13.3052C6.24219 13.3052 6.11426 13.2563 6.0166 13.1587C5.82129 12.9634 5.82129 12.647 6.0166 12.4517L8.8457 9.62207C9.0332 9.43457 9.36523 9.43457 9.55273 9.62207L10.6084 10.6777L13.2891 7.99658H12.375C12.0986 7.99658 11.875 7.77295 11.875 7.49658C11.875 7.22021 12.0986 6.99658 12.375 6.99658Z"
                          fill="#222222"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.1376 15.4301L20.8535 20.1465C21.0488 20.3418 21.0488 20.6582 20.8535 20.8535C20.7559 20.9512 20.6279 21 20.5 21C20.3721 21 20.2441 20.9512 20.1465 20.8535L15.4305 16.1371C14.1104 17.2932 12.3875 18 10.499 18C6.36426 18 3 14.6357 3 10.5C3 6.36426 6.36426 3 10.499 3C14.6348 3 18 6.36426 18 10.5C18 12.388 17.2933 14.1103 16.1376 15.4301ZM4 10.5C4 14.084 6.91504 17 10.499 17C14.084 17 17 14.084 17 10.5C17 6.91602 14.084 4 10.499 4C6.91504 4 4 6.91602 4 10.5Z"
                          fill="#222222"/>
                </svg>
                <span data-suggestPos="{{suggestPos}}" data-target="{{target}}" data-term="{{term}}"
                      class="pl_copy100 squirrel_searchSuggest__term js_squirrel_searchSuggest__term">{{{term}}}</span>
                <div class="squirrel_searchSuggest__right-icon">
                    <svg class="pl_icon" role="img">
                        <use xlink:href="/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"/>
                    </svg>
                </div>
            </div>
        </div>
    </li>
    {{/keywords}}
`;
